import * as React from 'react';
import './TablePagination.scss';

interface ITablePaginationProps {
  t: any;
  handlePagination(type: 'next' | 'previous'): void;
  pagination: {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
}

class TablePagination extends React.Component<ITablePaginationProps, any> {
  private getInitPage = (): number => {
    if (this.props.pagination.totalPages === 0) {
      return 0;
    }

    return this.props.pagination.pageNumber + 1;
  };

  private renderOnePage = () => {
    const { pagination } = this.props;
    return (
      <div className="rp-table--pagination">
        <span className="onePage">{`${pagination.totalPages} page`}</span>
      </div>
    );
  };

  private renderPages = () => {
    const { t, pagination, handlePagination } = this.props;
    return (
      <div className="rp-table--pagination">
        <i
          className={`rpds-chevron-left ${
            pagination.pageNumber <= 0 ? 'disabled' : ''
          }`}
          onClick={() => {
            handlePagination('previous');
          }}
        />
        <span>{`${this.getInitPage()} - ${pagination.totalPages} ${t(
          'common.pages'
        )}`}</span>
        <i
          className={`rpds-chevron-right ${
            this.getInitPage() === pagination.totalPages ? 'disabled' : ''
          }`}
          onClick={
            this.getInitPage() !== pagination.totalPages
              ? () => {
                  handlePagination('next');
                }
              : null
          }
        />
      </div>
    );
  };

  public render() {
    const { totalPages } = this.props.pagination;
    return totalPages === 1 ? this.renderOnePage() : this.renderPages();
  }
}

export default TablePagination;
